module.exports = __webpack_public_path__ + "static/media/credit-card.3d84f4e5.svg";